export const JobStatusEnum = {
    OPEN: { description: "Open", id: 1 },
    PAUSED: { description: "Paused", id: 10 },
    PENDING: { description: "Pending", id: 30 },
    CLOSE: { description: "Closed", id: 20 },
};
